import { useState, useEffect } from "react";
import { getSmilesSvg } from "../../views/Ranker/rankerApi";
import { CircularProgress } from "@mui/material";
import { getSvgFromCache, setSvgInCache } from "../../views/Ranker/svgCache";
import { isAxiosError } from "axios";
import { useAppDispatch } from "../../app/hooks";
import { setGlobalMsgAlerts } from "../GloablMsgAlerts/globalMsgAlertsSlice";
import { errorMessages } from "../../common_variables/ErrorMsgs";

const SvgRender = ({
  smiles,
  height,
  transitionScale,
}: {
  smiles: string;
  height?: string;
  transitionScale?: string;
}) => {
  const [svgSrc, setSvgSrc] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const globalDispatch = useAppDispatch();

  useEffect(() => {
    const cachedSvg = getSvgFromCache(smiles);
    if (cachedSvg) {
      setSvgSrc(cachedSvg);
      setIsLoading(false);
      return;
    }

    const fetchSvg = async () => {
      try {
        setIsLoading(true);
        const svgResponse = await getSmilesSvg([smiles]);
        const img = `data:image/svg+xml;base64,${btoa(
          svgResponse?.data?.[smiles]?.svg
        )}`;
        setSvgInCache(smiles, img);
        setSvgSrc(img);
      } catch (error) {
        let msg = "";
        if (isAxiosError(error)) {
          msg = error.response.data?.detail?.message;
        }
        msg = msg || "Unable to generate 2D represenation for some Smiles.";
        globalDispatch(
          setGlobalMsgAlerts({
            msg: msg,
            isAlert: true,
            color: "error",
          })
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchSvg();
  }, [smiles]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: height || "110px",
      }}
    >
      {isLoading ? (
        <CircularProgress size={50} />
      ) : (
        <img
          src={svgSrc}
          alt="2D svg representation"
          style={{
            height: "90%",
            width: "90%",
            transition: "transform 0.5s ease-in-out",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = transitionScale || "scale(1.1)")
          }
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />
      )}
    </div>
  );
};

export default SvgRender;
